import { createColumnHelper } from "@tanstack/react-table";
import PagedFilterTable from "../../../../components/table";
import IIdentifiers from "../../../../models/Identifiers";

const IdentityFieldsModal: React.FC<{ identifiers: IIdentifiers | null; showHistoryMetadata?: boolean }> = ({ identifiers, showHistoryMetadata = true }) => {
    const columnHelper = createColumnHelper<IIdentifiers>();
    const columns = [
        columnHelper.accessor('pin', {
            header: () => <span>PIN</span>,
            size: 30
        }),        
        columnHelper.accessor('bioID', {
            header: () => <span>BIO ID</span>,
            size: 30
        }),
        columnHelper.accessor('proxCard', {
            header: () => <span>Prox Card</span>,
            size: 30
        }), 
         columnHelper.accessor('magCard', {
            header: () => <span>Mag Card</span>,
            size: 30
        }), 
        ...(showHistoryMetadata ? [
            columnHelper.accessor('identityCreatedDate', {
                header: () => <span>Created Date</span>,
                size: 50
            }),
            columnHelper.accessor('identityModifiedDate', {
                header: () => <span>Modified Date</span>,
                size: 50
            }),
            columnHelper.accessor('identityModifiedBy', {
                header: () => <span>Modified By</span>,
                size: 50
            })
        ] : []),
    ];

    return (
        <div id="listView-data">
            <PagedFilterTable
                tableKey={`identity-fields-${identifiers?.crbcID}-${identifiers?.identityModifiedDate}`}
                columns={columns}
                data={identifiers ? [identifiers] : []}
                usePagination={false}
                pageRecords={25}
                useSearch={false}
            />
        </div>
    );
};

export default IdentityFieldsModal;